/**************************************************
 * Nombre:       Home_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {INDICADORES, NEGRITA} from "../../../Constantes";
import Tarjeta_Indicador from "../../Tarjetas/Tarjeta_Indicador";
import fondo from "../../../Recursos/fondo_indicadores.png";
import linea from "../../../Recursos/Iconos/ic_raya.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Indicadores = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'linear-gradient(180deg, rgba(48, 51, 118, 0.76) 0%, rgba(48, 51, 118, 0.76) 100%),  url(' + fondo + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: 12, pb: 24}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontWeight: 400,
                                fontFamily: NEGRITA,
                                fontSize: sCell ? 24 : 24,
                                textAlign: 'center',
                                textTransform: 'uppercase',
                                lineHeight: 1.4
                            }}>El Centro de Conciliación “Solución de Conflictos para la Paz” es una institución privada
                                autorizada para su funcionamiento por el Ministerio de Justicia y del Derecho mediante
                                Resolución No. 0325 del 10 de mayo de 2017, bajo su inspección, control y vigilancia.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                            <img src={linea} width={50} height={'auto'} alt={'linea'}/>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontWeight: 300, fontSize: sCell ? 16 : 16, textAlign: 'center'}}>
                                Somos constructores de paz. Orientamos nuestra gestión al acceso efectivo a la justicia,
                                la transformación pacífica de los conflictos y la construcción de acuerdos, bajo
                                principios de igualdad, inclusión, enfoque y perspectiva de género, respeto por la
                                diversidad, bienestar animal e interés superior de los niños, niñas y adolescentes.
\
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                            <img src={linea} width={50} height={'auto'} alt={'linea'}/>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontWeight: 300, fontSize: sCell ? 16 : 16, textAlign: 'center'}}>
                                Trabajamos con compromiso ético, calidad, transparencia, imparcialidad y enfoque humano,
                                convencidos de que el diálogo y la conciliación son herramientas esenciales para
                                fortalecer la convivencia y construir una sociedad más justa y en paz.
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 8}}
                            spacing={sCell ? 2 : 8}
                        >

                            {INDICADORES.map((it, index) => (
                                <Grid container size={{xs: 6, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Indicador item={it}/>
                                </Grid>
                            ))}


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Indicadores  